import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import isNil from 'ramda/src/isNil';

import UserPresenter from '../../../../../../presenters/UserPresenter';
import appRoutes from '../../../../../../routes/appRoutes';

const UserCellView = (props) => {
  const { user } = props;

  const hasUserFastCash = !isNil(UserPresenter.fastCash(user));
  const auth0Id = UserPresenter.auth0Id(user);

  return (
    <tr>
      <td>{auth0Id}</td>
      <td>{UserPresenter.fullName(user)}</td>
      <td>{UserPresenter.email(user)}</td>
      <td>{UserPresenter.membershipState(user)}</td>
      <td>{UserPresenter.birthdate(user)}</td>
      <td>{UserPresenter.gender(user)}</td>
      <td>{UserPresenter.phoneNumber(user)}</td>
      <td>{UserPresenter.createdAtReadable(user)}</td>
      <td>
        {hasUserFastCash && (
          <a
            href={appRoutes.userFastCashPath({ byAuth0Id: auth0Id })}
            target="_blank"
          >
            FastCash
          </a>
        )}
      </td>
    </tr>
  );
};

UserCellView.propTypes = {
  user: UserPresenter.shape().isRequired,
};

const UserCell = createFragmentContainer(UserCellView, {
  user: graphql`
    fragment UserCell_user on User {
      id
      auth0Id
      fullName
      email
      membershipState
      birthdate
      gender
      phoneNumber
      createdAt
      fastCash {
        id
      }
    }
  `,
});

export default UserCell;
